// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { OrderLineDetail } from './order-line-detail';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderLineDetailNote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get dateDisplay() {
        return moment(this.createDate).format('MM/DD/YYYY hh:mm:ssA');
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  assemblyNote!: boolean;
  createDate?: Date;
  createdById?: number;
  deleted?: Date;
  deletedBy?: string;
  manualNote!: boolean;
  note?: string;
  orderLineDetailId!: number;
  preAllocationNote!: boolean;
  preAssemblyNote!: boolean;
  createdBy!: User;
  orderLineDetail!: OrderLineDetail;
}

